import React from 'react';

export function IconArrowDown({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28">
      <path
        d="M20.219 11.5l-5.86 5.859L8.5 11.5"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}

export function IconUser({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28">
      <path
        fill="none"
        d="M5.346 23.902s.156-8.915 9.064-8.519 8.245 8.519 8.245 8.519z"
      />
      <g
        transform="translate(8.441 3)"
        stroke={color}
        strokeWidth="1.2"
        fill="none">
        <circle cx="5.328" cy="5.328" r="5.328" stroke="none" />
        <circle fill="none" cx="5.328" cy="5.328" r="4.728" />
      </g>
      <path
        d="M23.34 24.24s.831-9.122-9.175-9.149-9.147 9.149-9.147 9.149z"
        strokeLinecap="round"
        stroke={color}
        strokeWidth="1.2"
        fill="none"
      />
    </svg>
  );
}

export function IconNotification({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28">
      <path
        d="M24.591 19.318c-1.975-1.708-3.8-4.118-3.8-10.136a6.321 6.321 0 00-12.641 0c0 6.023-1.827 8.431-3.8 10.137a2.5 2.5 0 00-.87 1.887.719.719 0 00.719.719h6.823a3.52 3.52 0 006.891 0h6.823a.719.719 0 00.719-.719 2.489 2.489 0 00-.864-1.888zm-10.124 3.97a2.085 2.085 0 01-1.954-1.363h3.907a2.085 2.085 0 01-1.952 1.363zm-9.266-2.806a1.059 1.059 0 01.083-.081c3.014-2.6 4.3-5.959 4.3-11.224a4.883 4.883 0 019.765 0c0 5.26 1.286 8.617 4.3 11.224a1.068 1.068 0 01.084.08z"
        fill={color}
      />
    </svg>
  );
}

export function IconSearch({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28">
      <g stroke={color} strokeWidth="1" fill="none">
        <g transform="translate(5.397 4.923)">
          <circle cx="7.037" cy="7.037" r="7.037" stroke="none" />
          <circle cx="7.037" cy="7.037" r="6.037" />
        </g>
        <path d="M16.744 17.132l5.444 5.445" strokeLinecap="round" />
      </g>
    </svg>
  );
}

export function IconFavorite({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25">
      <path
        d="M21.219 5.228a5.117 5.117 0 00-8.169.588 7.788 7.788 0 00-.506.82 7.782 7.782 0 00-.506-.82 5.117 5.117 0 00-8.169-.588 6.158 6.158 0 00-1.482 4.089 7.541 7.541 0 002.077 4.948 46.237 46.237 0 005.2 4.856c.786.67 1.6 1.363 2.465 2.12l.026.023a.6.6 0 00.784 0l.026-.023c.865-.757 1.678-1.45 2.465-2.12a46.232 46.232 0 005.2-4.856 7.541 7.541 0 002.077-4.948 6.158 6.158 0 00-1.488-4.089zm-6.564 12.987a277.38 277.38 0 00-2.111 1.811 259.218 259.218 0 00-2.111-1.811c-4.129-3.518-6.856-5.843-6.856-8.9a4.969 4.969 0 011.185-3.3 3.973 3.973 0 013.025-1.361 4.012 4.012 0 013.28 1.849 7.056 7.056 0 01.911 1.812.6.6 0 001.132 0 7.057 7.057 0 01.911-1.812 3.928 3.928 0 016.305-.489 4.969 4.969 0 011.185 3.3c0 3.058-2.724 5.383-6.856 8.901z"
        fill={color}
      />
    </svg>
  );
}

export function IconStarEmpty({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14.301">
      <path
        d="M14.6 6.481a1.071 1.071 0 00-.591-1.828l-3.614-.525a.472.472 0 01-.356-.259L8.423.597a1.07 1.07 0 00-1.92 0L4.888 3.871a.473.473 0 01-.356.259l-3.615.523a1.07 1.07 0 00-.593 1.828L2.939 9.03a.473.473 0 01.136.418l-.617 3.6a1.07 1.07 0 001.553 1.128l3.232-1.7a.473.473 0 01.44 0l3.232 1.7a1.07 1.07 0 001.553-1.128l-.617-3.6a.473.473 0 01.136-.418zm-3.338 3.072l.617 3.6a.473.473 0 01-.686.5l-3.232-1.7a1.071 1.071 0 00-1 0l-3.232 1.7a.473.473 0 01-.686-.5l.617-3.6a1.07 1.07 0 00-.308-.947L.741 6.053A.473.473 0 011 5.247l3.614-.525a1.069 1.069 0 00.806-.586L7.039.861a.473.473 0 01.848 0L9.5 4.136a1.068 1.068 0 00.806.586l3.614.525a.473.473 0 01.262.806L11.57 8.602a1.07 1.07 0 00-.308.951z"
        fill={color}
      />
    </svg>
  );
}

export function IconStarFull({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14.301">
      <path
        fill={color}
        d="M7.474.211c-1.132 0-2.446 4.378-2.446 4.378s-4.2-.115-4.513.993 2.98 3.27 2.98 3.27-1.328 4.36-.26 5.036 4.124-1.867 4.124-1.867 3.514 2.571 4.464 1.867-.312-4.851-.312-4.851 3.266-2.311 2.889-3.454S10 4.465 10 4.465 8.607.211 7.474.211z"
      />
      <path
        fill={color}
        d="M14.6 6.481a1.071 1.071 0 00-.591-1.828l-3.614-.525a.472.472 0 01-.356-.259L8.423.597a1.07 1.07 0 00-1.92 0L4.888 3.871a.473.473 0 01-.356.259l-3.615.523a1.07 1.07 0 00-.593 1.828L2.939 9.03a.473.473 0 01.136.418l-.617 3.6a1.07 1.07 0 001.553 1.128l3.232-1.7a.473.473 0 01.44 0l3.232 1.7a1.07 1.07 0 001.553-1.128l-.617-3.6a.473.473 0 01.136-.418zm-3.338 3.072l.617 3.6a.473.473 0 01-.686.5l-3.232-1.7a1.071 1.071 0 00-1 0l-3.232 1.7a.473.473 0 01-.686-.5l.617-3.6a1.07 1.07 0 00-.308-.947L.741 6.053A.473.473 0 011 5.247l3.614-.525a1.069 1.069 0 00.806-.586L7.039.861a.473.473 0 01.848 0L9.5 4.136a1.068 1.068 0 00.806.586l3.614.525a.473.473 0 01.262.806L11.57 8.602a1.07 1.07 0 00-.308.951z"
      />
    </svg>
  );
}

export function IconArrowBreadcrumbs({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="7.924" height="13.02">
      <path
        d="M1.414 1.414l5.1 5.1-5.1 5.1"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeWidth="2"
      />
    </svg>
  );
}

export function IconCheck({color}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.438"
      height="10.401"
      viewBox="0 0 14.438 10.401">
      <path
        d="M377.391,247.094l4.037,4.037L389,243.558"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeWidth="2"
        transform="translate(-375.977 -242.144)"
      />
    </svg>
  );
}

export function IconCamera({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="52.347" height="42.487">
      <g>
        <path
          fill={color}
          d="M0 13.001v23.1a6.392 6.392 0 006.389 6.389h39.57a6.392 6.392 0 006.389-6.389v-23.1a6.082 6.082 0 00-6.079-6.079h-8.5l-.2-.887a7.766 7.766 0 00-7.606-6.036h-7.582a7.783 7.783 0 00-7.606 6.036l-.2.887H6.079A6.089 6.089 0 000 13.001zM15.619 9.54a1.3 1.3 0 001.271-1.015l.438-1.9a5.167 5.167 0 015.053-4.006h7.574a5.167 5.167 0 015.053 4.006l.438 1.9a1.313 1.313 0 001.271 1.015h9.54a3.461 3.461 0 013.461 3.461v23.1a3.771 3.771 0 01-3.771 3.771H6.389a3.771 3.771 0 01-3.771-3.771v-23.1A3.461 3.461 0 016.079 9.54z"
        />
        <circle
          fill={color}
          cx="1.752"
          cy="1.752"
          r="1.752"
          transform="translate(7.104 13.375)"
        />
        <path
          fill={color}
          d="M26.174 35.767a10.993 10.993 0 10-10.993-10.993 11.011 11.011 0 0010.993 10.993zm0-19.368a8.376 8.376 0 11-8.376 8.376 8.389 8.389 0 018.376-8.377z"
        />
      </g>
    </svg>
  );
}

export function IconRemove({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23.885" height="29.408">
      <path
        fill={color}
        d="M16.005 10.651a.689.689 0 00-.689.689v13.017a.689.689 0 001.377 0V11.343a.689.689 0 00-.688-.692zm0 0M7.879 10.651a.689.689 0 00-.689.689v13.017a.689.689 0 001.377 0V11.343a.689.689 0 00-.688-.692zm0 0"
      />
      <path
        fill={color}
        d="M1.956 8.755v16.968a3.8 3.8 0 001.01 2.621 3.392 3.392 0 002.461 1.064h13.03a3.391 3.391 0 002.461-1.064 3.8 3.8 0 001.01-2.621V8.755a2.631 2.631 0 00-.675-5.174h-3.526V2.72A2.705 2.705 0 0015.003.001H8.884a2.705 2.705 0 00-2.727 2.72v.86H2.631a2.631 2.631 0 00-.675 5.174zm16.5 19.275H5.427a2.181 2.181 0 01-2.094-2.307V8.815h17.218v16.908a2.181 2.181 0 01-2.094 2.307zM7.534 2.72a1.327 1.327 0 011.35-1.343h6.119a1.327 1.327 0 011.35 1.343v.861H7.534zm-4.9 2.238h18.619a1.24 1.24 0 010 2.479H2.631a1.24 1.24 0 010-2.479zm0 0"
      />
      <path
        fill={color}
        d="M11.942 10.651a.689.689 0 00-.689.689v13.017a.689.689 0 001.377 0V11.343a.689.689 0 00-.688-.692zm0 0"
      />
    </svg>
  );
}

export function IconAdverts({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25">
      <g
        transform="translate(2 8)"
        strokeWidth="1.2"
        stroke={color}
        fill="none">
        <rect width="21" height="13" rx="2" stroke="none" />
        <rect x=".6" y=".6" width="19.8" height="11.8" rx="1.4" />
      </g>
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        d="M6.353 5.776h12.125M9.605 4h6.087"
      />
    </svg>
  );
}

export function IconStore({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25">
      <path
        d="M21.337 8.423l-.757-2.648A2.556 2.556 0 0018.228 4H6.13a2.556 2.556 0 00-2.353 1.775l-.756 2.648A.538.538 0 003 8.57v1.73a2.269 2.269 0 001.44 2.11v6.819a1.98 1.98 0 001.978 1.978H17.94a1.98 1.98 0 001.978-1.978v-6.821a2.269 2.269 0 001.44-2.11V8.57a.538.538 0 00-.021-.147zM4.812 6.07a1.5 1.5 0 011.318-.994h12.1a1.5 1.5 0 011.319.995l.561 1.962H4.251zm2.72 3.038h2.381V10.3a1.19 1.19 0 11-2.381 0zm3.456 0h2.381V10.3a1.19 1.19 0 11-2.381 0zm3.456 0h2.381V10.3a1.19 1.19 0 11-2.381 0zM4.076 10.3V9.108h2.38V10.3a1.19 1.19 0 11-2.381 0zm7.488 9.83v-3.245h1.8v3.245zm6.375 0h-3.494v-3.783a.538.538 0 00-.538-.538h-2.88a.538.538 0 00-.538.538v3.783H6.418a.9.9 0 01-.9-.9v-6.679a2.263 2.263 0 001.478-.789 2.262 2.262 0 003.456 0 2.262 2.262 0 003.456 0 2.262 2.262 0 003.456 0 2.264 2.264 0 001.478.789v6.677a.9.9 0 01-.902.902zm1.152-8.641A1.192 1.192 0 0117.9 10.3V9.108h2.381V10.3a1.192 1.192 0 01-1.189 1.189zm0 0"
        fill={color}
      />
    </svg>
  );
}

export function IconBuy({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25">
      <path
        d="M20.946 6.523a1.8 1.8 0 00-1.381-.61H6.351l-.133-1A2.017 2.017 0 004.515 3h-.971a.544.544 0 000 1.088h.971c.175 0 .544.369.624.972L6.7 16.737a2.2 2.2 0 00.745 1.357 2.248 2.248 0 001.044.519 2 2 0 103.538.039h2.85a2 2 0 103.558 0h1.425a.544.544 0 100-1.088H8.884a1.167 1.167 0 01-1.11-.972l-.114-.853H18.4a2.258 2.258 0 002.188-1.916l.78-5.851a1.8 1.8 0 00-.422-1.449zm-9.79 13.042a.913.913 0 11-.913-.912.914.914 0 01.913.912zm6.408 0a.913.913 0 11-.913-.912.914.914 0 01.914.912zM20.29 7.829l-.78 5.851a1.167 1.167 0 01-1.11.972H7.516L6.5 7h13.07a.7.7 0 01.725.828zm0 0"
        fill={color}
      />
    </svg>
  );
}

export function IconConfig({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25">
      <path
        fill={color}
        d="M20.9 10.452l-1.324-.225a7.476 7.476 0 00-.532-1.285l.78-1.092a1.162 1.162 0 00-.126-1.5l-1.176-1.175a1.157 1.157 0 00-.824-.343 1.145 1.145 0 00-.674.217l-1.1.78a7.4 7.4 0 00-1.324-.547l-.224-1.309a1.164 1.164 0 00-1.15-.974h-1.659a1.164 1.164 0 00-1.151.974l-.229 1.34a7.292 7.292 0 00-1.281.54l-1.084-.78a1.164 1.164 0 00-1.5.126L5.144 6.373a1.166 1.166 0 00-.126 1.5l.788 1.107a7.3 7.3 0 00-.524 1.289l-1.309.222A1.164 1.164 0 003 11.642v1.657a1.164 1.164 0 00.973 1.151l1.34.229a7.292 7.292 0 00.54 1.281l-.776 1.08a1.162 1.162 0 00.126 1.5l1.174 1.174a1.157 1.157 0 00.824.343 1.145 1.145 0 00.674-.217l1.107-.788a7.455 7.455 0 001.245.512l.221 1.324a1.164 1.164 0 001.151.973h1.663a1.164 1.164 0 001.151-.973l.225-1.324a7.476 7.476 0 001.285-.532l1.092.78a1.157 1.157 0 00.678.217 1.157 1.157 0 00.824-.343l1.174-1.174a1.166 1.166 0 00.126-1.5l-.78-1.1a7.423 7.423 0 00.532-1.285l1.324-.221a1.164 1.164 0 00.973-1.151v-1.656a1.15 1.15 0 00-.966-1.147zm-.091 2.81a.1.1 0 01-.087.1l-1.655.276a.529.529 0 00-.426.39 6.308 6.308 0 01-.686 1.651.533.533 0 00.024.579l.973 1.371a.107.107 0 01-.012.134l-1.174 1.174a.1.1 0 01-.075.032.1.1 0 01-.059-.02l-1.367-.973a.532.532 0 00-.579-.024 6.308 6.308 0 01-1.651.686.523.523 0 00-.39.426l-.28 1.655a.1.1 0 01-.1.087H11.6a.1.1 0 01-.1-.087l-.276-1.655a.529.529 0 00-.39-.426 6.55 6.55 0 01-1.616-.662.545.545 0 00-.268-.071.519.519 0 00-.307.1l-1.379.981a.117.117 0 01-.059.02.106.106 0 01-.075-.032l-1.175-1.175a.107.107 0 01-.012-.134l.969-1.359a.539.539 0 00.024-.583 6.249 6.249 0 01-.694-1.647.54.54 0 00-.426-.39l-1.665-.287a.1.1 0 01-.087-.1v-1.657a.1.1 0 01.087-.1l1.643-.276a.533.533 0 00.43-.394A6.3 6.3 0 016.9 9.214a.526.526 0 00-.03-.575L5.888 7.26a.107.107 0 01.012-.134l1.175-1.175a.1.1 0 01.075-.032.1.1 0 01.059.02l1.359.969a.539.539 0 00.583.024 6.249 6.249 0 011.649-.693.54.54 0 00.39-.426l.284-1.667a.1.1 0 01.1-.087h1.659a.1.1 0 01.1.087l.276 1.643a.533.533 0 00.394.43 6.4 6.4 0 011.69.694.533.533 0 00.579-.024l1.359-.977a.117.117 0 01.059-.02.106.106 0 01.075.032l1.178 1.175a.107.107 0 01.012.134l-.973 1.366a.532.532 0 00-.024.579 6.308 6.308 0 01.686 1.651.523.523 0 00.426.39l1.655.28a.1.1 0 01.087.1v1.659z"
      />
      <path
        fill={color}
        d="M12.434 8.358a4.071 4.071 0 104.071 4.071 4.073 4.073 0 00-4.071-4.071zm0 7.077a3.007 3.007 0 113.007-3.007 3.009 3.009 0 01-3.007 3.008z"
      />
    </svg>
  );
}

export function IconArrow({color, style}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={style}>
      <path
        d="M15.5 11.499l8.048 8.048-8.048 8.048"
        stroke={color}
        strokeLinecap="round"
        strokeWidth="2"
        fill="none"
      />
    </svg>
  );
}

export function IconVoucher({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="13">
      <path
        fill={color}
        d="M21.568 3.813A.433.433 0 0022 3.378V.434A.433.433 0 0021.568 0H.432A.433.433 0 000 .434v2.944a.433.433 0 00.432.434 2.688 2.688 0 010 5.375.433.433 0 00-.432.435v2.944A.433.433 0 00.432 13h3.836a.434.434 0 000-.868H.863v-2.1a3.559 3.559 0 000-7.059V.868h14.821v.868a.432.432 0 10.863 0V.868h4.589v2.1a3.559 3.559 0 000 7.059v2.1h-4.589v-.868a.432.432 0 10-.863 0v.868H7.812a.434.434 0 000 .868h13.756a.433.433 0 00.432-.429V9.622a.433.433 0 00-.432-.434 2.688 2.688 0 010-5.375zm0 0"
      />
      <path
        fill={color}
        d="M16.112 8.55a.44.44 0 00.44-.44V4.89a.44.44 0 10-.88 0v3.22a.44.44 0 00.44.44zm0 0M9.224 5.911a1.73 1.73 0 10-1.222.505 1.717 1.717 0 001.222-.505zM7.155 4.689a.848.848 0 11.248.6.842.842 0 01-.248-.6zm0 0M10.634 7.297a1.728 1.728 0 102.444 0 1.73 1.73 0 00-2.444 0zm1.821.622a.848.848 0 11-.6-.248.849.849 0 01.605.249zm0 0M7.948 9.224l4.585-4.585a.44.44 0 00-.623-.622L7.325 8.602a.44.44 0 10.622.622zm0 0M6.036 12.116a.44.44 0 10.432.357.444.444 0 00-.432-.357zm0 0"
      />
    </svg>
  );
}

export function IconEdit({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="29.475" height="29.327">
      <path
        fill={color}
        d="M27.2 18.404a.734.734 0 00-.734.734v6.518a2.2 2.2 0 01-2.2 2.2H3.67a2.2 2.2 0 01-2.2-2.2V6.526a2.2 2.2 0 012.2-2.2h6.518a.734.734 0 100-1.468H3.67A3.675 3.675 0 000 6.526v19.13a3.675 3.675 0 003.67 3.67h20.6a3.675 3.675 0 003.67-3.67v-6.518a.734.734 0 00-.74-.734zm0 0"
      />
      <path
        fill={color}
        d="M27.652.967a3.3 3.3 0 00-4.672 0l-13.1 13.1a.734.734 0 00-.188.323L7.97 20.608a.734.734 0 00.9.9l6.218-1.722a.734.734 0 00.323-.188l13.1-13.1a3.307 3.307 0 000-4.672zM11.479 14.539L22.197 3.822l3.455 3.457-10.717 10.719zm-.69 1.386l2.762 2.762-3.82 1.058zM27.471 5.462l-.779.779-3.457-3.457.779-.779a1.835 1.835 0 012.6 0l.862.861a1.838 1.838 0 01-.005 2.596zm0 0"
      />
    </svg>
  );
}

export function IconDelete({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23.885" height="29.408">
      <path
        fill={color}
        d="M16.005 10.651a.689.689 0 00-.689.689v13.017a.689.689 0 001.377 0V11.343a.689.689 0 00-.688-.692zm0 0M7.879 10.651a.689.689 0 00-.689.689v13.017a.689.689 0 001.377 0V11.343a.689.689 0 00-.688-.692zm0 0"
      />
      <path
        fill={color}
        d="M1.956 8.755v16.968a3.8 3.8 0 001.01 2.621 3.392 3.392 0 002.461 1.064h13.03a3.391 3.391 0 002.461-1.064 3.8 3.8 0 001.01-2.621V8.755a2.631 2.631 0 00-.675-5.174h-3.526V2.72A2.705 2.705 0 0015.003.001H8.884a2.705 2.705 0 00-2.727 2.72v.86H2.631a2.631 2.631 0 00-.675 5.174zm16.5 19.275H5.427a2.181 2.181 0 01-2.094-2.307V8.815h17.218v16.908a2.181 2.181 0 01-2.094 2.307zM7.534 2.72a1.327 1.327 0 011.35-1.343h6.119a1.327 1.327 0 011.35 1.343v.861H7.534zm-4.9 2.238h18.619a1.24 1.24 0 010 2.479H2.631a1.24 1.24 0 010-2.479zm0 0"
      />
      <path
        fill={color}
        d="M11.942 10.651a.689.689 0 00-.689.689v13.017a.689.689 0 001.377 0V11.343a.689.689 0 00-.688-.692zm0 0"
      />
    </svg>
  );
}

export function IconChat({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
      <path
        d="M5.842 3.748v10.6h10.467l3.3 3.268.868-3.027 2.18-.241V3.563z"
        fill="none"
      />
      <path
        fill={color}
        d="M6.979 2.656a2.114 2.114 0 00-2.11 2.11v8.393a2.114 2.114 0 002.11 2.11h9.457l2.665 3.085a.847.847 0 001.489-.551v-2.53h.6a2.114 2.114 0 002.11-2.11v-8.4a2.114 2.114 0 00-2.11-2.11zm15.175 2.11v8.393a.968.968 0 01-.966.966h-1.172a.574.574 0 00-.574.574v2.3l-2.315-2.675a.567.567 0 00-.434-.2H6.979a.968.968 0 01-.966-.966v-8.4a.968.968 0 01.966-.966h14.209a.968.968 0 01.966.974z"
      />
      <path
        fill={color}
        d="M4.285 22.046a.845.845 0 00.3.056.834.834 0 00.635-.294l2.665-3.085h8.327a.574.574 0 000-1.148h-8.59a.574.574 0 00-.434.2l-2.311 2.684v-2.3a.574.574 0 00-.574-.574H3.132a.968.968 0 01-.966-.966V8.22a.968.968 0 01.966-.966.572.572 0 100-1.144 2.114 2.114 0 00-2.11 2.11v8.393a2.114 2.114 0 002.11 2.11h.6v2.53a.832.832 0 00.553.793z"
      />
    </svg>
  );
}

export function IconMessages({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33">
      <path
        d="M7.948 4.775V19.69h14.73l4.646 4.6 1.224-4.261 3.068-.339V4.515z"
        fill="none"
      />
      <path
        fill={color}
        d="M9.549 3.238A2.974 2.974 0 006.58 6.207v11.809a2.974 2.974 0 002.969 2.972h13.306l3.75 4.341a1.192 1.192 0 002.1-.775v-3.566h.847a2.974 2.974 0 002.969-2.969V6.207a2.974 2.974 0 00-2.969-2.969zm21.352 2.969v11.809a1.362 1.362 0 01-1.36 1.36h-1.649a.807.807 0 00-.808.808v3.238l-3.258-3.763a.8.8 0 00-.611-.276H9.549a1.362 1.362 0 01-1.36-1.36V6.207a1.362 1.362 0 011.36-1.36h19.992a1.362 1.362 0 011.36 1.36z"
      />
      <path
        fill={color}
        d="M5.758 30.52a1.189 1.189 0 00.42.079 1.173 1.173 0 00.893-.414l3.75-4.341h11.718a.808.808 0 100-1.616H10.454a.808.808 0 00-.611.276l-3.251 3.777v-3.238a.807.807 0 00-.808-.808H4.136a1.362 1.362 0 01-1.36-1.36V11.067a1.362 1.362 0 011.36-1.36.804.804 0 100-1.609 2.974 2.974 0 00-2.969 2.969v11.809a2.974 2.974 0 002.969 2.972h.847v3.56a1.171 1.171 0 00.775 1.112z"
      />
    </svg>
  );
}

export function IconFacebook({color}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.737"
      height="23.291"
      viewBox="0 0 10.737 23.291">
      <g transform="translate(-16 -11)">
        <path
          fill={color}
          d="M48.117,33.386H44.932V45.054H40.107V33.386H37.812v-4.1h2.295V26.632c0-1.9.9-4.869,4.868-4.869l3.574.015v3.98H45.956a.982.982,0,0,0-1.024,1.118v2.413h3.606Z"
          transform="translate(-21.812 -10.763)"
        />
      </g>
    </svg>
  );
}

export function IconInstagram({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24.5" height="24.16">
      <path
        fill={color}
        d="M0 7.353c.081-.573.143-1.15.246-1.719A6.305 6.305 0 016.377.104a167.61 167.61 0 0111.8 0 6.314 6.314 0 016.235 6.311q.177 5.659 0 11.328a6.313 6.313 0 01-6.235 6.311c-3.929.142-7.871.145-11.8 0a6.423 6.423 0 01-6.246-6.328c-.021-.308-.087-.613-.131-.919zm12.253 14.594c1.8 0 3.6.054 5.393-.012a4.387 4.387 0 004.613-4.6q.122-5.257 0-10.519a4.359 4.359 0 00-4.613-4.591q-5.358-.113-10.719 0a4.333 4.333 0 00-4.605 4.524q-.144 5.323 0 10.653c.076 2.781 1.813 4.426 4.605 4.53 1.773.069 3.551.015 5.326.015zm0 0"
      />
      <path
        fill={color}
        d="M12.249 5.841a6.243 6.243 0 106.243 6.243 6.243 6.243 0 00-6.243-6.243zm0 10.336a4.094 4.094 0 114.094-4.094 4.094 4.094 0 01-4.094 4.091zm0 0M20.343 5.553a1.485 1.485 0 11-1.485-1.485 1.485 1.485 0 011.485 1.485zm0 0"
      />
    </svg>
  );
}

export function IconLinkedin({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24.202" height="23.127">
      <path
        d="M24.202 14.178v8.953h-5.189v-8.353c0-2.1-.749-3.528-2.628-3.528a2.838 2.838 0 00-2.661 1.9 3.551 3.551 0 00-.172 1.264v8.717H8.364s.07-14.141 0-15.6h5.189v2.2c-.01.017-.025.034-.034.051h.034v-.051a5.152 5.152 0 014.679-2.575c3.414 0 5.973 2.23 5.973 7.022zM2.932 0a2.7 2.7 0 10-.068 5.393h.034A2.7 2.7 0 102.932 0zM.308 23.131h5.187v-15.6H.308z"
        fill={color}
      />
    </svg>
  );
}

export function IconTwitter({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22.544" height="18.321">
      <path
        d="M22.544 2.172a9.228 9.228 0 01-2.657.727A4.638 4.638 0 0021.921.341a9.259 9.259 0 01-2.937 1.122 4.629 4.629 0 00-7.882 4.219A13.129 13.129 0 011.569.849a4.63 4.63 0 001.428 6.172 4.592 4.592 0 01-2.095-.579v.059a4.628 4.628 0 003.71 4.535 4.643 4.643 0 01-2.089.08 4.63 4.63 0 004.321 3.212 9.337 9.337 0 01-6.847 1.915A13.153 13.153 0 0020.249 5.161c0-.2 0-.4-.013-.6a9.379 9.379 0 002.308-2.389z"
        fill={color}
      />
    </svg>
  );
}

export function IconUpload({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28">
      <g stroke={color}>
        <g transform="translate(4.777 5)" strokeWidth="1.5" fill="#fff">
          <rect stroke="none" width="18" height="19" rx="2" />
          <rect
            fill="none"
            x="-.75"
            y="-.75"
            width="19.5"
            height="20.5"
            rx="2.75"
          />
        </g>
        <path
          d="M4 19.925l4.347-4.549 3.923 4.105 6.4-6.7 4.875 5.1"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <g transform="translate(7.777 8)" strokeWidth="1.2" fill="#fff">
          <circle stroke="none" cx="2.5" cy="2.5" r="2.5" />
          <circle fill="none" cx="2.5" cy="2.5" r="1.9" />
        </g>
      </g>
    </svg>
  );
}

export function IconMicrophone({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28">
      <g stroke={color} strokeWidth="1.5">
        <g transform="translate(9 3)" fill="#fff">
          <rect width="9" height="15" rx="4.5" stroke="none" />
          <rect
            x=".75"
            y=".75"
            width="7.5"
            height="13.5"
            rx="3.75"
            fill="none"
          />
        </g>
        <path
          d="M6.739 13.3s.5 7.114 7.039 7.083 6.907-7.083 6.907-7.083"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
        />
        <path d="M13.712 20.387v4.271" fill="none" />
        <path d="M9.7 25.027h7.818" strokeLinecap="round" fill="none" />
      </g>
    </svg>
  );
}

export function IconClose({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12.828" height="12.828">
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeWidth="2"
        d="M11.414 1.415l-10 10M11.414 11.414l-10-10"
      />
    </svg>
  );
}

export function IconBack({color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10.571" height="19.14">
      <path
        d="M9.157 1.414L1.001 9.57l8.156 8.156"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}

export function IconArrowSlider({color, style}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      style={style}>
      <g stroke={color} strokeWidth="2" fill="none">
        <circle stroke="none" cx="25" cy="25" r="25" />
        <circle fill="none" cx="25" cy="25" r="24" />
      </g>
      <path
        d="M21.5 16.5l8.048 8.048-8.048 8.048"
        strokeLinecap="round"
        stroke={color}
        strokeWidth="2"
        fill="none"
      />
    </svg>
  );
}
